import logger from "./logger";

export default {
  createData,
};

/**
 *
 * @param {*} data
 * @param {*} riverInfo
 */
function createData(data, riverInfo) {
  // パラメータ初期化
  var crossData = initializeParams(data);

  // 英語化で河床がnullの場合は値を、河川内最低標高をセットする
  if (riverInfo.sys === "ph2" && isEmpty(riverInfo.rvrbed)) {
    setRvrBed(data.points, riverInfo);
  }
  if (isEmpty(riverInfo.rvrwid)) {
    throw new Error(getErrorMsg(riverInfo.sys, "ER001"));
  }

  // 標高値補完処理
  completmentElevation(data.points, riverInfo);

  // 川幅から横の表示倍率決定
  if (!riverInfo.isPresentOut) {
    setDisplayMagnification(data.points[300].distance, riverInfo);
  } else {
    setDisplayMagnification(data.totalDistance, riverInfo);
  }

  riverInfo.divWidth *= riverInfo.display.drawWidthMag;

  // 描画上下位置決定
  setDisplayPotision(data, riverInfo, crossData);

  // riverInfoに必要情報を格納
  riverInfo.crossData = crossData;
  riverInfo.data = data;

  // return crossData;
}

/**
 * パラメータ初期化
 * @param {*} data
 */
function initializeParams(data) {
  var result = {
    scale: 1,
    width: 650,
    height: 400,
  };

  var graphMax = data.max;
  var graphMin = data.min > 0 ? 0 : data.min;

  if (graphMin == graphMax) graphMax += 100;

  result.max = graphMax;
  result.min = graphMin;
  result.h = graphMax - graphMin;
  result.height = Math.round(result.height * result.scale);
  result.stepY = 0;
  result.stepMinusY = 0;

  {
    var splitNum = Math.round(result.height / 32);
    if (splitNum <= 1) {
      result.stepY = result.max / 2;
      if (result.stepY < 0) result.stepY = 1000;
    } else {
      result.stepY = Math.round(result.h / splitNum);

      if (result.stepY <= 100) {
        result.stepY = Math.floor(result.stepY / 10) * 10;
      } else if (result.stepY < 1000)
        result.stepY = Math.floor(result.stepY / 100) * 100;

      if (result.stepY <= 50) {
        if (result.h <= 10) result.stepY = 1;
        else if (result.h <= 50) result.stepY = 5;
      }

      if (result.stepY == 0) result.stepY = 50;
    }
  }

  if (graphMin < 0) {
    result.stepMinusY = result.stepY;
    graphMin =
      -Math.ceil(Math.abs(graphMin) / result.stepMinusY) * result.stepMinusY -
      result.stepMinusY / 2;

    result.min = graphMin;
    result.h = graphMax - graphMin;
  }

  return result;
}

/**
 * 河川内最低標高を河床に設定
 * @param {*} points
 * @param {*} riverInfo
 */
function setRvrBed(points, riverInfo) {
  //   var points = this._data.points;
  //   var riverInfo = this._riverInfo;
  var min = null;

  for (var i = riverInfo.leftBankIdx; i < riverInfo.rightBankIdx; i++) {
    var p = points[i];
    if (isEmpty(p)) continue;
    if (min === null || p.h < min) min = p.h;
  }
  riverInfo.rvrbed = min;
  logger.debug("河床:" + riverInfo.rvrbed);
}

/**
 * 標高値補完処理
 * @param {*} points
 * @param {*} riverInfo
 */
function completmentElevation(points, riverInfo) {
  try {
    // AとBのオブジェクト作成
    // A'→AとB'→Bの順で標高値が入るようにセット
    var leftArr = [];
    var rightArr = [];

    // 左端と右端の位置
    var leftIdx = riverInfo.leftBankIdx;
    var rightIdx = riverInfo.rightBankIdx;

    for (var i = 0; i < points.length; i++) {
      var p = points[i];
      // 左端と右端の間(堤外地)はスルー
      if (i > leftIdx && i < rightIdx) continue;
      if (i <= leftIdx) leftArr.unshift(p.h);
      else if (i >= rightIdx) rightArr.push(p.h);
    }

    // 左岸補完初期値
    var leftCompValue = getLeftComValue(riverInfo);
    // 補完実行
    var compLeftArr = execComp(leftArr, leftCompValue);
    // 左岸の値をもとに戻す
    leftBankReplace(points, compLeftArr, leftIdx);

    // 右岸補完初期値
    var rightCompValue = getRightComValue(riverInfo);
    // 補完実行
    var compRightArr = execComp(rightArr, rightCompValue);
    // 右岸の値をもとに戻す
    rightBankReplace(points, compRightArr, rightIdx);
  } catch (err) {
    throw new Error(getErrorMsg(this._riverInfo.sys, "ER001"));
  }
}

/**
 * 左岸補完初期値取得
 * @param {*} riverInfo
 */
function getLeftComValue(riverInfo) {
  var leftCompValue = riverInfo.leftBankInfo.elevation;
  var points = riverInfo.points;
  if (points.length > 0) leftCompValue = points[0].drawHeight;
  return leftCompValue;
}

/**
 * 右岸補完初期値取得
 * @param {*} riverInfo
 */
function getRightComValue(riverInfo) {
  var rightCompValue = riverInfo.rightBankInfo.elevation;
  var points = riverInfo.points;
  var n = riverInfo.points.length;
  // 横断データ有る場合は補完に使う値は縦データの先頭の値
  if (n > 0) rightCompValue = points[n - 1].drawHeight;
  return rightCompValue;
}

// 標高値補完実行
function execComp(arr, compValue) {
  // 最初の標高値は補正値を必ず入れる
  arr[0] = compValue;

  // 2番めの値から補完処理を行う
  for (var i = 1; i <= arr.length - 1; i++) {
    var h = arr[i];
    var isProper = false;

    // 標高取得地点の標高がかつ-9999以外の数値だったら正常とみなす
    isProper = !isEmpty(h) && h !== -9999;
    // 正常なら補完用の値を更新, 異常なら補完用の値で補完、次の値へ
    if (isProper === true) compValue = h;
    else if (isProper === false) arr[i] = compValue;
  }
  return arr;
}

/**
 * 左岸標高値入れ替え
 * @param {*} points
 * @param {*} arr
 * @param {*} idx
 */
function leftBankReplace(points, arr, idx) {
  for (var i = 0; i <= idx; i++) {
    points[i].h = arr[idx - i];
  }
}

/**
 * 右岸標高値入れ替え
 * @param {*} points
 * @param {*} arr
 * @param {*} idx
 */
function rightBankReplace(points, arr, idx) {
  for (var i = idx; i < points.length; i++) {
    points[i].h = arr[i - idx];
  }
}

/**
 * 川幅から横の表示倍率決定
 * @param {*} riverInfo
 */
function setDisplayMagnification(totalDistance, riverInfo) {
  //   var riverInfo = this._riverInfo;
  var rvrwid = riverInfo.rvrwid;
  // var totalDistance = data.totalDistance;
  riverInfo.display = {};

  // 倍率決定に用いる閾値取得
  if (isEmpty(riverInfo.rvrwidCfg1)) riverInfo.rvrwidCfg1 = 30;
  if (isEmpty(riverInfo.rvrwidCfg2)) riverInfo.rvrwidCfg2 = 100;

  // 川幅から、川部分を画面幅の何%の大きさで描画するか決定
  var percent = riverInfo.rvrwidRatioDefault;
  if (rvrwid >= riverInfo.rvrwidCfg2) {
    percent = riverInfo.rvrwidRatio2;
  } else if (rvrwid >= riverInfo.rvrwidCfg1) {
    percent = riverInfo.rvrwidRatio1;
  }

  // 堤内地含めた総距離内で、河川域が占める割合
  var radioRiver = rvrwid / (totalDistance * 1000);
  // 川幅を上で決めた%で補正
  var correctedRiver = (rvrwid / radioRiver) * percent;
  // 川幅補正値算出
  riverInfo.display.drawWidthMag = correctedRiver / rvrwid;
}

/**
 *
 * @param {*} data
 * @param {*} riverInfo
 * @param {*} crossData
 */
function setDisplayPotision(data, riverInfo, crossData) {
  // 描画位置上限
  var max = riverInfo.upgate;
  if (isEmpty(max)) max = undefined;
  riverInfo.display.drawMaxValue = max;

  // 描画位置下限
  riverInfo.display.drawMinValue = getLowPotision(
    riverInfo,
    data.points,
    crossData
  );
}

function getLowPotision(riverInfo, points, crossData) {
  let low = null;
  let high = null;

  // 横断有りの英語化の場合のみ河床標高、
  // それ以外の場合は観測開始水位を最低描画位置にする
  if (riverInfo.sys === "ph2" && riverInfo.points.length > 0) {
    low = riverInfo.rvrbed;
    high = riverInfo.upgate;
  } else if (riverInfo.sys === "ph2") {
    // 横断無しの英語化の場合も観測開始水位(扱い)を最低描画位置にする
    low = riverInfo.strtStage;
  } else {
    let upgate = riverInfo.upgate;
    low = riverInfo.strtStage;
    if (!isEmpty(upgate)) {
      high = upgate;
    }
  }

  // 最低標高値取得処理
  // 観測開始水位が無い場合は標高最低値を返して終了
  if (isEmpty(low)) return crossData.min;

  // 天端高や氾濫水位が無い場合は標高最高値を使用
  if (isEmpty(high)) high = crossData.max;
  let minArray = getMinArray(points, riverInfo, low);

  let min = low;
  // 堤内地で一番低い標高を最低値にセット
  if (minArray.length > 0) min = Math.min.apply(null, minArray);

  // let heightDiff = (high - low) * 2.5;
  // return high - heightDiff < min ? min : high - heightDiff;
  return min;
}

function getMinArray(p, riverInfo, low) {
  var left = riverInfo.leftBankIdx;
  var right = riverInfo.rightBankIdx;
  var minArray = [];

  // lowより低い堤内地の標高を全て取得
  for (var i = 0; i < p.length; i++) {
    if (isEmpty(p[i + 1])) break;
    if ((i + 1 >= left && i + 1 <= right) || p[i].h === -9999) continue;
    if (p[i].h < low) minArray.push(p[i].h);
  }

  return minArray;
}

/**
 * undefined・ null・ false・ 空配列・ 空オブジェクト・ 空文字・ スペースのみはtrue
 * @param {*} value
 */
function isEmpty(value) {
  if (value === undefined) return true;
  if (value === null) return true;
  if (value === false) return true;
  if (value === true) return false;
  if (typeof value === "object") return value.length === 0;
  if (typeof value === "string") return value.replace(/\s+/gi, "").length === 0;
  if (typeof value === "number") return false;
  if (typeof value === "function") return false;
}

var errorMess = {
  ph2: {
    /*
        "ER001": "Failed cross-section drawing. Error code: ER001",
        "ER002": "Failed cross-section drawing. Error code: ER002",
        "ER003": "Failed cross-section drawing. Error code: ER003"
        */
    ER001: "横断図の描画に失敗しました。",
    ER002: "河川情報の取得に失敗しました。",
    ER003: "標高データの取得に失敗しました。",
  },
  swin: {
    ER001: "横断図の描画に失敗しました。",
    ER002: "河川情報の取得に失敗しました。",
    ER003: "標高データの取得に失敗しました。",
  },
  allStageNull: "観測値がないため、水位を描画できません",
};

function getErrorMsg(sys, code) {
  return errorMess[sys][code] || "横断図の描画に失敗しました。";
}
